webpackJsonp([1],{

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlantedPanel = exports.SectionPanel = exports.SectionImage = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Section = _react2.default.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      theme = _ref.theme;
  return _react2.default.createElement(
    "section",
    { ref: ref, className: "section " + className + " " + (theme ? "section--" + theme : "") },
    children
  );
});

var SectionImage = exports.SectionImage = function SectionImage(_ref2) {
  var src = _ref2.src;
  return _react2.default.createElement("div", {
    className: "section__image",
    style: { backgroundImage: "url(" + src + ")" }
  });
};

var SectionPanel = exports.SectionPanel = function SectionPanel(_ref3) {
  var children = _ref3.children,
      right = _ref3.right,
      _ref3$slanted = _ref3.slanted,
      slanted = _ref3$slanted === undefined ? false : _ref3$slanted,
      width = _ref3.width;

  var classNames = "section__panel";

  if (right) classNames += " section__panel--right";
  if (slanted) classNames += " section__panel--slanted";

  return _react2.default.createElement(
    "div",
    { className: "section__content", style: { width: width || null } },
    _react2.default.createElement(
      "div",
      { className: classNames },
      children
    )
  );
};

var SlantedPanel = exports.SlantedPanel = function SlantedPanel(_ref4) {
  var _ref4$className = _ref4.className,
      className = _ref4$className === undefined ? "" : _ref4$className,
      _ref4$direction = _ref4.direction,
      direction = _ref4$direction === undefined ? "left" : _ref4$direction,
      children = _ref4.children;
  return _react2.default.createElement(
    "div",
    { className: "slanted-panel slanted-panel--" + direction + " " + className },
    _react2.default.createElement(
      "div",
      { className: "section__content" },
      children
    )
  );
};

exports.default = Section;

/***/ }),

/***/ 138:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hero = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(140);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hero = exports.Hero = function Hero(_ref) {
  var heading = _ref.heading,
      subheading = _ref.subheading,
      _ref$image = _ref.image,
      image = _ref$image === undefined ? "" : _ref$image,
      large = _ref.large;
  return _react2.default.createElement(
    "div",
    { className: "hero " + (large ? "hero--large" : "") },
    _react2.default.createElement(
      "div",
      { className: "hero-image-wrapper" },
      _react2.default.createElement("div", {
        className: "hero-image",
        style: { backgroundImage: "url(" + image + ")" }
      })
    ),
    _react2.default.createElement(
      "div",
      { className: "hero-text" },
      heading && _react2.default.createElement(
        "h1",
        { className: "hero__heading" },
        heading
      ),
      subheading && _react2.default.createElement(
        "p",
        { className: "hero__sub-heading" },
        subheading
      )
    )
  );
};

exports.default = Hero;

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaffCard = function StaffCard(_ref) {
    var _ref$name = _ref.name,
        name = _ref$name === undefined ? "" : _ref$name,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        _ref$picture = _ref.picture,
        picture = _ref$picture === undefined ? null : _ref$picture,
        bio = _ref.bio,
        isSelected = _ref.isSelected,
        onClick = _ref.onClick;
    return _react2.default.createElement(
        'button',
        { className: 'staff-card ' + (isSelected ? 'staff-card--selected' : ''), onClick: onClick },
        _react2.default.createElement(
            'div',
            { className: 'staff-card__pic-container' },
            _react2.default.createElement('img', { className: 'staff-card__pic', alt: 'picture of ' + name, src: picture })
        ),
        _react2.default.createElement(
            'div',
            { className: 'staff-card__info' },
            _react2.default.createElement(
                'span',
                { className: 'staff-card__name' },
                name
            ),
            _react2.default.createElement(
                'span',
                { className: 'staff-card__title' },
                title
            )
        ),
        bio && _react2.default.createElement(
            'div',
            { className: 'staff-card__bio' },
            _react2.default.createElement(
                'p',
                { className: 'staff-card__bio-blurb' },
                bio
            )
        )
    );
};

exports.default = StaffCard;

/***/ }),

/***/ 149:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/aea_school_help.18a1f9e0.jpg";

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/profile-placeholder.94d390bc.png";

/***/ }),

/***/ 152:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(11);

var _reactHelmet = __webpack_require__(22);

var _Section = __webpack_require__(137);

var _Section2 = _interopRequireDefault(_Section);

var _Hero = __webpack_require__(139);

var _Hero2 = _interopRequireDefault(_Hero);

var _StaffCard = __webpack_require__(148);

var _StaffCard2 = _interopRequireDefault(_StaffCard);

var _aea_school_help = __webpack_require__(150);

var _aea_school_help2 = _interopRequireDefault(_aea_school_help);

var _profilePlaceholder = __webpack_require__(151);

var _profilePlaceholder2 = _interopRequireDefault(_profilePlaceholder);

__webpack_require__(152);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var About = function About(_ref) {
  var _ref$pageData = _ref.pageData,
      heading = _ref$pageData.heading,
      heroImageLg = _ref$pageData.heroImageLg,
      teamMembers = _ref$pageData.teamMembers;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      selectedMemberIdx = _useState2[0],
      setSelectedMemberIdx = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showBio = _useState4[0],
      setShowBio = _useState4[1];

  var teamMemberSectionRef = (0, _react.useRef)();
  var hasSelectedMember = Number.isInteger(selectedMemberIdx);

  function onTeamMemberClick(idx) {
    setSelectedMemberIdx(idx);

    if (teamMemberSectionRef.current) {
      window.scrollTo({
        top: teamMemberSectionRef.current.offsetTop - 15,
        left: 0,
        behavior: 'smooth'
      });
    }

    setTimeout(function () {
      setShowBio(true);
    }, 400);
  }

  function onShowAllTeamMembers() {
    setSelectedMemberIdx(null);
    setShowBio(false);
  }

  return _react2.default.createElement(
    "div",
    { className: "about" },
    _react2.default.createElement(
      _reactHelmet.Helmet,
      null,
      _react2.default.createElement(
        "title",
        null,
        "Amour En Action | About Us"
      )
    ),
    _react2.default.createElement(_Hero2.default, { heading: heading, image: heroImageLg }),
    _react2.default.createElement(
      _Section2.default,
      { theme: "light-grain" },
      _react2.default.createElement(
        _Section.SectionPanel,
        { padded: true },
        _react2.default.createElement(
          "h2",
          null,
          "Organized With Purpose"
        ),
        _react2.default.createElement(
          "p",
          null,
          "Amour en Action, Inc was incorporated to provide a means to those who wish to personally engage in making a difference in the lives of needy Haitian children, providing assistance in the area of education, nutrition, healthcare and other developmental initiatives."
        )
      )
    ),
    _react2.default.createElement(
      _Section2.default,
      { className: "staff-section " + (showBio ? 'staff-section--bio' : ''), theme: "medium-gray", ref: teamMemberSectionRef },
      _react2.default.createElement(
        _Section.SectionPanel,
        { padded: true },
        _react2.default.createElement(
          "div",
          { className: "about-staff " + (hasSelectedMember ? 'about-staff--bio' : '') },
          teamMembers.map(function (member, idx) {
            return _react2.default.createElement(_StaffCard2.default, {
              key: "sc-" + idx,
              name: member.name,
              title: member.title,
              picture: member.picture || _profilePlaceholder2.default,
              bio: member.shortBio,
              isSelected: selectedMemberIdx === idx,
              onClick: function onClick() {
                return onTeamMemberClick(idx);
              }
            });
          })
        ),
        showBio && teamMembers && teamMembers[selectedMemberIdx] && teamMembers[selectedMemberIdx].shortBio && _react2.default.createElement(
          "div",
          { className: "bio" },
          _react2.default.createElement(
            "button",
            { type: "button", onClick: onShowAllTeamMembers },
            "See all team members"
          ),
          _react2.default.createElement(
            "p",
            null,
            teamMembers[selectedMemberIdx].shortBio
          )
        )
      )
    ),
    _react2.default.createElement(
      _Section2.default,
      { className: "accomplishments-section" },
      _react2.default.createElement(_Section.SectionImage, { src: _aea_school_help2.default }),
      _react2.default.createElement(
        _Section.SlantedPanel,
        null,
        _react2.default.createElement(
          "div",
          { className: "about-accomplishments" },
          _react2.default.createElement(
            "h2",
            null,
            "Some Accomplishments"
          ),
          _react2.default.createElement(
            "span",
            null,
            "In Haiti"
          ),
          _react2.default.createElement(
            "ul",
            null,
            _react2.default.createElement(
              "li",
              null,
              "Operation of a free school for over 150 needy children"
            ),
            _react2.default.createElement(
              "li",
              null,
              "Half way in the construction of a school to house over 200 children"
            ),
            _react2.default.createElement(
              "li",
              null,
              "Organization of Medical Mission Trips"
            ),
            _react2.default.createElement(
              "li",
              null,
              "Christmas parties with gift donations to Haitian children"
            )
          ),
          _react2.default.createElement(
            "span",
            null,
            "In The US"
          ),
          _react2.default.createElement(
            "ul",
            null,
            _react2.default.createElement(
              "li",
              null,
              "Incorporation of the organization"
            ),
            _react2.default.createElement(
              "li",
              null,
              "Fundraising concerts and banquets"
            ),
            _react2.default.createElement(
              "li",
              null,
              "Family Conference"
            )
          )
        )
      )
    )
  );
};

exports.default = function () {
  return _react2.default.createElement(_reactStatic.RouteData, { component: About });
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/pages/About/About.140eb2d1.js